(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initOrionHeaderAdoptPrice() {
      var button = document.querySelector('[data-orion-header-adopt-button]');
      var trigger = document.querySelector('.orion-perspective-cta');
      if (!button || !trigger) return;

      var price = button.getAttribute('data-current-price');
      var priceNode = button.querySelector('.orion-header-adopt-button__price');
      if (price && priceNode) priceNode.textContent = price;

      function updateButtonState() {
        var triggerTop = trigger.getBoundingClientRect().top;
        var shouldShowPrice = triggerTop <= window.innerHeight * 0.55;
        button.classList.toggle('is-price-visible', shouldShowPrice);
      }

      updateButtonState();
      window.addEventListener('scroll', updateButtonState, { passive: true });
      window.addEventListener('resize', updateButtonState);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOrionHeaderAdoptPrice);
    } else {
      initOrionHeaderAdoptPrice();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const initHomeHeroCarousels = (root = document) => {
    root.querySelectorAll('[data-home-hero-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;

      const desktopMedia = window.matchMedia('(min-width: 750px)');
      const desktopTemplate = carousel.querySelector('[data-home-hero-desktop-slides]');
      let desktopAdded = false;
      let slides = [];
      let activeIndex = 0;
      const updateSlides = () => {
        if (desktopMedia.matches && desktopTemplate && !desktopAdded) {
          carousel.append(desktopTemplate.content.cloneNode(true));
          desktopAdded = true;
        }
        const allSlides = Array.from(carousel.querySelectorAll('[data-home-hero-slide]'));
        slides = allSlides.filter((slide) => desktopMedia.matches || !slide.hasAttribute('data-desktop-only'));
        allSlides.forEach((slide) => {
          slide.classList.remove('is-active');
          slide.setAttribute('aria-hidden', 'true');
        });
        activeIndex = 0;
        slides[0].classList.add('is-active');
        slides[0].setAttribute('aria-hidden', 'false');
      };
      updateSlides();
      desktopMedia.addEventListener('change', updateSlides);
      if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      carousel.dataset.carouselReady = 'true';

      window.setInterval(() => {
        slides[activeIndex].classList.remove('is-active');
        slides[activeIndex].setAttribute('aria-hidden', 'true');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
        slides[activeIndex].setAttribute('aria-hidden', 'false');
      }, 10000);
    });
  };

  initHomeHeroCarousels();
  document.addEventListener('shopify:section:load', (event) => initHomeHeroCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notre-essence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-orion-essence-reveal]';
    const ITEM_SELECTOR = '[data-orion-essence-item]';

    const setupReveal = (sectionElement) => {
      if (!sectionElement || sectionElement.dataset.orionEssenceReady === 'true') return;

      sectionElement.dataset.orionEssenceReady = 'true';

      const revealItems = Array.from(sectionElement.querySelectorAll(ITEM_SELECTOR));
      if (revealItems.length === 0) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        sectionElement.dataset.orionEssenceAnimated = 'true';
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            requestAnimationFrame(() => {
              entry.target.classList.add('is-visible');
            });

            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.32,
          rootMargin: '0px 0px -6% 0px',
        }
      );

      revealItems.forEach((item) => {
        observer.observe(item);
      });
    };

    const initReveals = (root = document) => {
      if (root.matches && root.matches(SELECTOR)) {
        setupReveal(root);
      }

      root.querySelectorAll(SELECTOR).forEach((sectionElement) => {
        setupReveal(sectionElement);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initReveals(), { once: true });
    } else {
      initReveals();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initReveals(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-customer-photo-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCustomerPhotos = (root = document) => {
      root.querySelectorAll('[data-orion-customer-photos]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const track = section.querySelector('[data-orion-customer-photos-track]');
        const previous = section.querySelector('[data-orion-customer-photos-previous]');
        const next = section.querySelector('[data-orion-customer-photos-next]');
        if (!track || !previous || !next) return;

        const updateButtons = () => {
          const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const hasOverflow = maximumScroll > 2;
          previous.disabled = !hasOverflow;
          next.disabled = !hasOverflow;
        };

        const move = (direction) => {
          const item = track.querySelector('.orion-customer-photos__item');
          if (!item) return;
          const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
          const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);

          if (direction > 0 && track.scrollLeft >= maximumScroll - 2) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }

          if (direction < 0 && track.scrollLeft <= 2) {
            track.scrollTo({ left: maximumScroll, behavior: 'smooth' });
            return;
          }

          track.scrollBy({ left: direction * (item.offsetWidth + gap) * 2, behavior: 'smooth' });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons, { passive: true });
        updateButtons();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeCustomerPhotos(), { once: true });
    } else {
      initializeCustomerPhotos();
    }

    document.addEventListener('shopify:section:load', (event) => initializeCustomerPhotos(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orion-photo-gallery')) {
  customElements.define('orion-photo-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const figures = [...this.querySelectorAll('figure[data-product]')];
      const filters = this.querySelector('.orion-gallery__filters');
      const labels = [...new Set(figures.map(figure => figure.dataset.product))];
      const more = this.querySelector('.orion-gallery__more');
      let selectedLabel;
      const select = label => {
        selectedLabel = label;
        let count = 0;
        figures.forEach(figure => {
          const matches = figure.dataset.product === label;
          if (matches) count += 1;
          figure.hidden = !matches || count > 15;
        });
        more.hidden = count <= 15;
        [...filters.children].forEach(button => button.setAttribute('aria-pressed', String(button.textContent === label)));
      };
      labels.forEach(label => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.addEventListener('click', () => select(label));
        filters.append(button);
      });
      if (labels.length) select(labels[0]);
      more.addEventListener('click', () => {
        const firstNew = figures.find(figure => figure.hidden && figure.dataset.product === selectedLabel);
        figures.forEach(figure => { figure.hidden = figure.dataset.product !== selectedLabel; });
        more.hidden = true;
        if (firstNew) firstNew.querySelector('a').focus({ preventScroll: true });
      });
      const dialog = this.querySelector('dialog');
      const large = dialog.querySelector('img');
      this.querySelectorAll('.orion-gallery__zoom').forEach(link => {
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.opener = link;
          large.src = link.href;
          large.alt = link.querySelector('img').alt;
          dialog.showModal();
        });
      });
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { if (this.opener) this.opener.focus(); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-perspective-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var option = event.target.closest('.orion-perspective-cta [data-color-value]');
    if (!option) return;

    var group = option.closest('[data-orion-launch-color]');
    if (!group) return;

    group.querySelectorAll('[data-color-value]').forEach(function (button) {
      var isActive = button === option;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const translations = [
      ['Delighted with my Orion bag', '“I am really delighted with my Orion Chien Chic bag! It is elegant, practical and comfortable for my little dog. I love its design, which is different from traditional carriers, and it is very pleasant to carry every day. My dog feels comfortable in it and can easily come everywhere with me. The quality is there and the finishes are lovely. 🐶🤍 I recommend it without hesitation to anyone looking for a chic, practical and comfortable carrier!”'],
      ['This bag is gorgeous!', '“This bag is gorgeous!”'],
      ['Just like a real handbag', '“It truly feels just like a handbag. I have already received several compliments without anyone realising it was a pet carrier. When I explain it, everyone is amazed. It is really practical.”'],
      ['I am absolutely delighted', '“I am absolutely delighted with my purchase for my Japanese Spaniel! The leather interior is an excellent idea because it is so quick to clean. It should be offered in every pet carrier, especially for long-haired pets. It also looks fantastic. I am not usually a handbag person, but this feels like having one — only better! My little dog and I are both delighted.”'],
      ['An elegant bag', '“An elegant and very practical bag, with a comfortable mattress for my dog. Definitely approved!”'],
      ['Perfect — I recommend it', '“I was worried it might look like a disguised pet carrier. Not at all! It is a genuinely beautiful handbag, and my friends ask where it comes from. My Yorkshire loves it too!”'],
    ];

    document.querySelectorAll('[data-orion-trustpilot]').forEach((section) => {
      const button = section.querySelector('[data-review-translate]');
      if (!button) return;
      const reviews = Array.from(section.querySelectorAll('.orion-trustpilot__review'));
      const originals = reviews.map((review) => [review.querySelector('h3')?.textContent || '', review.querySelector('blockquote')?.textContent || '']);
      button.addEventListener('click', () => {
        const translated = button.getAttribute('aria-pressed') !== 'true';
        reviews.forEach((review, index) => {
          const copy = translated ? translations[index] : originals[index];
          if (!copy) return;
          review.querySelector('h3').textContent = copy[0];
          review.querySelector('blockquote').textContent = copy[1];
        });
        button.setAttribute('aria-pressed', String(translated));
        button.textContent = translated ? 'See original reviews in French' : 'See reviews translated into my language';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-story-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-orion-story-slider]';
    const REVEAL_SELECTOR = '[data-orion-story-reveal]';
    const syncStoryHeaderState = () => {
      document.body.classList.add('orion-story-page');

      const header = document.querySelector('#header-component');
      if (!header) return;

      header.dataset.stickyState = 'active';
      header.dataset.scrollDirection = 'none';
    };

    const setupStorySlider = (sectionElement) => {
      if (!sectionElement || sectionElement.dataset.orionStoryReady === 'true') return;

      const slides = Array.from(sectionElement.querySelectorAll('[data-orion-story-slide]'));
      const previousButton = sectionElement.querySelector('[data-orion-story-previous]');
      const nextButton = sectionElement.querySelector('[data-orion-story-next]');
      const slidesTrack = sectionElement.querySelector('[data-orion-story-track]');

      if (slides.length === 0 || !slidesTrack) return;

      sectionElement.dataset.orionStoryReady = 'true';

      const updateTrackHeight = () => {
        let tallestSlide = 0;

        slides.forEach((slide) => {
          const previousPosition = slide.style.position;
          const previousVisibility = slide.style.visibility;
          const previousOpacity = slide.style.opacity;
          const previousPointerEvents = slide.style.pointerEvents;
          const previousTransform = slide.style.transform;

          slide.style.position = 'relative';
          slide.style.visibility = 'visible';
          slide.style.opacity = '1';
          slide.style.pointerEvents = 'none';
          slide.style.transform = 'none';

          tallestSlide = Math.max(tallestSlide, slide.offsetHeight);

          slide.style.position = previousPosition;
          slide.style.visibility = previousVisibility;
          slide.style.opacity = previousOpacity;
          slide.style.pointerEvents = previousPointerEvents;
          slide.style.transform = previousTransform;
        });

        slidesTrack.style.setProperty('--orion-story-slides-height', `${tallestSlide}px`);
      };

      const updateButtons = (index) => {
        if (previousButton) previousButton.disabled = index <= 0;
        if (nextButton) nextButton.disabled = index >= slides.length - 1;
      };

      const showSlide = (requestedIndex) => {
        const nextIndex = Math.max(0, Math.min(requestedIndex, slides.length - 1));
        sectionElement.dataset.activeSlide = String(nextIndex);

        slides.forEach((slide, currentIndex) => {
          const isActive = currentIndex === nextIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        updateButtons(nextIndex);
      };

      if (previousButton) {
        previousButton.addEventListener('click', (event) => {
          event.preventDefault();
          showSlide(Number(sectionElement.dataset.activeSlide || 0) - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', (event) => {
          event.preventDefault();
          showSlide(Number(sectionElement.dataset.activeSlide || 0) + 1);
        });
      }

      sectionElement.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showSlide(Number(sectionElement.dataset.activeSlide || 0) - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showSlide(Number(sectionElement.dataset.activeSlide || 0) + 1);
        }
      });

      const onResize = () => updateTrackHeight();
      window.addEventListener('resize', onResize, { passive: true });

      updateTrackHeight();
      showSlide(Number(sectionElement.dataset.activeSlide || 0));
    };

    const setupStoryReveal = (sectionElement) => {
      if (!sectionElement || sectionElement.dataset.orionStoryRevealReady === 'true') return;

      sectionElement.dataset.orionStoryRevealReady = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        sectionElement.dataset.orionStoryState = 'visible';
        sectionElement.dataset.orionStoryAnimated = 'true';
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || sectionElement.dataset.orionStoryAnimated === 'true') return;

            requestAnimationFrame(() => {
              sectionElement.dataset.orionStoryState = 'visible';
              sectionElement.dataset.orionStoryAnimated = 'true';
            });

            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.34,
          rootMargin: '0px 0px -6% 0px',
        }
      );

      observer.observe(sectionElement);
    };

    const initStorySliders = (root = document) => {
      syncStoryHeaderState();

      if (root.matches && root.matches(REVEAL_SELECTOR)) {
        setupStoryReveal(root);
      }

      root.querySelectorAll(REVEAL_SELECTOR).forEach((sectionElement) => {
        setupStoryReveal(sectionElement);
      });

      root.querySelectorAll(SELECTOR).forEach((sectionElement) => {
        setupStorySlider(sectionElement);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initStorySliders(), { once: true });
    } else {
      initStorySliders();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initStorySliders(event.target);
    });

    window.addEventListener('load', syncStoryHeaderState, { once: true });

    document.addEventListener('shopify:block:select', (event) => {
      const sectionElement = event.target.closest(SELECTOR);
      if (!sectionElement) return;

      const slides = Array.from(sectionElement.querySelectorAll('[data-orion-story-slide]'));
      const selectedSlide = event.target.closest('[data-orion-story-slide]');
      const selectedIndex = slides.indexOf(selectedSlide);

      if (selectedIndex < 0) return;

      sectionElement.dataset.activeSlide = String(selectedIndex);
      slides.forEach((slide, currentIndex) => {
        const isActive = currentIndex === selectedIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-style-callout"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-orion-style-reveal]';

    const revealSection = (sectionElement, observer) => {
      if (sectionElement.dataset.orionStyleAnimated === 'true') return;

      requestAnimationFrame(() => {
        sectionElement.dataset.orionStyleState = 'visible';
        sectionElement.dataset.orionStyleAnimated = 'true';
      });

      if (observer) observer.unobserve(sectionElement);
    };

    const setupSection = (sectionElement) => {
      if (!sectionElement || sectionElement.dataset.orionStyleReady === 'true') return;

      sectionElement.dataset.orionStyleReady = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        sectionElement.dataset.orionStyleState = 'visible';
        sectionElement.dataset.orionStyleAnimated = 'true';
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            revealSection(entry.target, observer);
          });
        },
        {
          threshold: 0.22,
          rootMargin: '0px 0px -10% 0px',
        }
      );

      observer.observe(sectionElement);
    };

    const initSections = (root = document) => {
      if (root.matches && root.matches(SELECTOR)) {
        setupSection(root);
      }

      root.querySelectorAll(SELECTOR).forEach((sectionElement) => {
        setupSection(sectionElement);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSections(), { once: true });
    } else {
      initSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-product-video-banner-variant-id]');
    if (!button) return;

    event.preventDefault();

    const productFormComponent = document.querySelector('product-form-component');
    const variantInput = productFormComponent ? productFormComponent.querySelector('input[name="id"]') : null;
    const variantId = (variantInput && variantInput.value) || button.getAttribute('data-product-video-banner-variant-id');

    if (!variantId) {
      window.location.href = '/cart';
      return;
    }

    button.disabled = true;

    try {
      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error('Cart add failed');
      }

      const currentUrl = new URL(window.location.href);
      const cartUrl = new URL(`${window.location.origin}/cart`);
      ['preview_theme_id', '_fd', 'pb'].forEach((param) => {
        const value = currentUrl.searchParams.get(param);
        if (value) {
          cartUrl.searchParams.set(param, value);
        }
      });

      window.location.href = cartUrl.toString();
    } catch (error) {
      window.location.href = '/cart';
    } finally {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
